import React, { useContext, useRef } from "react";
import { TranslationContext } from "../../contexts/TranslationContext";
import { NavPage } from "../../services/NavService";
import { CabinetClient, IUserSearchResult } from "../../services/WebApiClient";
import { useClient } from "../../util/useClient";
import { useState2 } from "../../util/useState2";
import { ReceiptModal } from "../CabinetList/ReceiptModal";
import { TopNav } from "../TopNav/TopNav";
import { CustomerSearchTable } from "./CustomerSearchTable";
import { UserModal } from "./UserModal";


export function CustomerSearch(props: {

}) {

    const tc = useContext(TranslationContext);
    const searchField = useRef<HTMLInputElement>(null);
    const searchString = useState2("");
    const selectedUserId = useState2<string>();
    const userList = useState2<IUserSearchResult[]>();
    const showReceiptForId = useState2<string>();
    const cabinetClient = useClient(CabinetClient);

    const showReceiptFor = userList.value
        ?.flatMap(u => u.solutions)
        ?.find(us => us.id === showReceiptForId.value);

    async function updateUserList() {
        const response = await cabinetClient.findCustomers(searchString.value);
        userList.set(response.searchResults);
    }
    async function search(evt: React.FormEvent) {
        evt.preventDefault();
        searchField.current?.select();
        await updateUserList();
    }


    const selectedUser = userList.value?.find(u => u.userId === selectedUserId.value);

    return (
        <div className="editor user-search">
            <TopNav header={tc.translator(NavPage.User.UserSearch)} />

            <div className="main-editor">
                <form onSubmit={search}>
                    <div className="input-group input-group-lg mb-3" style={{ maxWidth: "600px" }}>
                        <input className="form-control"
                            value={searchString.value}
                            ref={searchField}
                            type="search"
                            autoFocus
                            placeholder={tc.translator('user search search field placeholder', 'Kundens Navn, telefonnummer eller mail-adresse')}
                            onChange={evt => searchString.set(evt.target.value)}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-primary"
                                disabled={!searchString.value}
                                style={{ minWidth: "110px" }}
                            >
                                {tc.translator("user search button", "Søg")}
                            </button>
                        </div>
                    </div>
                </form>

                {/*{searchString.value && <CustomerSearchTableOuter*/}
                {/*    q={searchString.value}*/}
                {/*    onSelectUser={updateSelectedUser}/>}*/}
                {userList.value && <CustomerSearchTable
                    onSelectUser={u => selectedUserId.set(u.userId)}
                    results={userList.value}
                />}

                {selectedUser && <UserModal onClose={() => selectedUserId.set(undefined)}
                    user={selectedUser}
                    orderChanged={updateUserList}
                    onOrderComplete={us => showReceiptForId.set(us.id)}
                />}

                {showReceiptFor?.orderNumber &&
                    <ReceiptModal
                        onClose={() => showReceiptForId.set(undefined)}
                        userSolution={showReceiptFor}
                    />
                }
            </div>
        </div>
    );
}
